<script>
  import { page } from '@inertiajs/svelte';
  import { onDestroy, onMount } from 'svelte';

  export let hero;

  $: text = hero.desc ? hero.desc.split('') : '';

  let typedText = '';
  let interval;
  let index = 0;

  function typeText() {
    if (index < text.length) {
      typedText += text[index];
      index++;
    } else {
      clearInterval(interval);
    }
  }

  function handlePlayClick() {}

  onMount(() => {
    interval = setInterval(() => {
      typeText();
    }, 75);
  });

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<div class="hero-bottom">
  <div class="hero-bottom__c2a">
    <p class="text-small">{typedText}</p>
  </div>
  {#if hero.portfolio}
    <div class="hero-bottom__more">
      <a href="{hero.portfolio}?showreel=1" class="btn btn-icon btn-simple">
        <span>{$page.props.i18n.play_showreel}</span>
        <i class="isax isax-arrow-right-1" />
      </a>
    </div>
  {/if}
</div>

<style lang="scss">
  .hero-bottom {
    @include resp-max('m') {
      align-items: center;
      flex-direction: column;

      padding: 5.7rem 0 3rem;
    }

    @include resp-range('s', 'm') {
      margin-top: 8rem;
    }

    @include resp-min('m') {
      align-items: flex-end;
      justify-content: space-between;

      padding: 7.8rem 0 4.2rem;
    }

    display: flex;

    :global .hero--hide-content & {
      opacity: 0;
    }

    &__c2a {
      @include resp-min('m') {
        max-width: 19rem;
      }

      @include resp-max('m') {
        text-align: center;
      }

      &-flag {
        display: inline-block;
        margin-bottom: -2px;
      }
    }

    &__more {
      @include resp-max('m') {
        margin-top: 3rem;
      }
    }
  }
</style>
